import { downloadBase64 } from '../utils/downloadFiles';

import { api, apiCertificationsMaster } from './apiInstances';

export const getTeams = async () => {
  const result = await api.get(`/v1/SolicitudesServicio/equipos`);

  return result.data;
};

export const ubicationsSS = async (value) => {
  const result = await api.get(`/v1/SolicitudesServicio/ubicaciones/${value}`);

  return result.data;
};

export const getPriorities = async () => {
  const response = await api.get('/v1/SolicitudesServicio/prioridades');

  return response.data;
};

export const typeTabGrid = async ({ grillaEnum }) => {
  const result = await api.get(`/v1/SolicitudesServicio/grilla/${grillaEnum}/estados`);

  return result.data;
};

export const statusSS = async () => {
  const result = await api.get(`/v1/SolicitudesServicio/estados`);

  return result.data;
};

export const postGridRequest = async (filters, source) => {
  const result = await api.post('/v1/SolicitudesServicio/grid', filters, {
    cancelToken: source?.token
  });

  return result.data;
};

export const postCreateMultipleServiceRequest = async (params) => {
  const response = await api.post('/v1/SolicitudesServicio', params);

  return response.data;
};

export const getfilterPreference = async () => {
  const result = await api.get(`/v1/SolicitudesServicio/preferenciasFiltros/me`);

  return result.data;
};

export const postFilterPreference = async (filters) => {
  const result = await api.post('/v1/SolicitudesServicio/preferenciasFiltros/me', filters);

  return result.data;
};

export const getMultipleDraft = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicio/${id}/borrador`);

  return result.data;
};

export const deleteDraft = async (id) => {
  const result = await api.delete(`/v1/SolicitudesServicio/${id}/borrador`);

  return result;
};

export const updateDraft = async (id, values) => {
  const result = await api.put(`/v1/SolicitudesServicio/${id}`, values);

  return result.data;
};

export const updateMultipleDraft = async (gsdsNumber, values) => {
  const params = new URLSearchParams();

  if (gsdsNumber) params.append('numeroGsds', gsdsNumber);
  const result = await api.put(`/v1/SolicitudesServicio?${params}`, values);

  return result.data;
};

export const getApprovers = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicio/${id}/aprobadores`);

  return result.data;
};

export const updateApprovers = async (id, approvers) => {
  const result = await api.put(`/v1/SolicitudesServicio/${id}/aprobadores`, approvers);

  return result.data;
};

export const contractsSS = async (value) => {
  const result = await api.get(`/v1/SolicitudesServicio/contratos/${value}`);

  return result.data;
};

export const usersSS = async (value) => {
  const result = await api.get(`/v1/SolicitudesServicio/usuarios/${value}`);

  return result.data;
};

// Cabecera
export const getDetailsHeader = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicio/${id}/cabecera`);

  return result.data;
};

export const getUbicationDetail = async (id) => {
  const result = await api.get(`/V2/SolicitudesServicio/${id}/detalleUbicacion`);

  return result.data;
};

export const getUbicationDetailOyM = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicio/${id}/detalleUbicacionOym`);

  return result.data;
};

// UPDATE UBICATION DETAILS V2
export const putUbicationDetail = async (id, values) => {
  const result = await api.put(`/V1/SolicitudesServicio/${id}/pozos`, values);

  return result.data;
};

export const putUbicationDetailOyM = async (id, values) => {
  const result = await api.put(`/v1/SolicitudesServicio/${id}/detalleUbicacionOym`, values);

  return result.data;
};

// POST PROVIDERS
export const postProviders = async (params, id) => {
  const result = await api.post(`/v1/SolicitudesServicio/${id}/proveedores`, params);

  return result.data;
};

// ASSIGNATION PROVIDER
export const putAssignationProvider = async (
  idSDS,
  providerId,
  providerName,
  reassignmentReason = null
) => {
  const result = await api.put(`/v1/SolicitudesServicio/${idSDS}/asignacion`, {
    id: providerId,
    nombre: providerName,
    motivoReasignacion: reassignmentReason
  });

  return result.data;
};

// PESTAÑA SOLICITADO A

export const getRequestTo = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicio/${id}/proveedoresSolicitados`);

  return result.data;
};

// GET HISTORIAL

export const getHistory = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicio/${id}/historial`);

  return result.data;
};

// PESTAÑA MENSAJES
export const getMessages = async (id, skip, pageSize = 10) => {
  const result = await api.get(
    `/v1/SolicitudesServicio/${id}/mensajes?Skip=${skip}&PageSize=${pageSize}`
  );

  return result.data;
};

export const sendMessage = async (id, param) => {
  const result = await api.post(`/v1/SolicitudesServicio/${id}/nuevoMensaje`, param);

  return result.data;
};

// PESTAÑA COMUNICAR
// Comunicar a y Copia a
export const getCommunicateTo = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicio/${id}/comunicarA`);

  return result.data;
};

// PUT DESTINATARIOS-copia a
export const putCommunicateTo = async (params, id) => {
  const result = await api.put(`/v1/SolicitudesServicio/${id}/destinatariosEnCopia`, params);

  return result.data;
};

// Boton Cancelar la SDS
export const putCancel = async (id) => {
  const result = await api.put(`/v1/SolicitudesServicio/${id}/cancelacion`);

  return result.data;
};

// Clasificacion de rechazo
export const getRejectionClassification = async () => {
  const result = await api.get(`/v1/SolicitudesServicio/clasificacionRechazo`);

  return result.data;
};

export const patchReschedulingDates = async (id, body) => {
  const result = await api.patch(`/v1/SolicitudesServicio/${id}/reprogramacion`, body);

  return result.data;
};

// Botones Aceptar/Rechazar/Cancelar aceptacion SDS -Proveedor Administrador
export const patchResponseProvider = async (params, id) => {
  const result = await api.patch(`v1/SolicitudesServicio/${id}/respuestaProveedor`, params);

  return result.data;
};

export const putFinalizeService = async (id, body) => {
  const result = await api.put(`/v1/SolicitudesServicio/${id}/finalizacion`, body);

  return result.data;
};

// Obtener combo de posiciones + lineas
export const getPosLin = async (id, monthly) => {
  const assignmentTypeQueryParam = monthly ? '?tipoAsignacion=3' : '';
  const result = await api.get(
    `/v1/SolicitudesServicio/${id}/partesTrabajo/lineas${assignmentTypeQueryParam}`
  );

  return result.data;
};

// Obtener solicitudes asociadas en detalle de una GSDS
export const getModalMultipleServiceRequest = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicio/solicitudesAsociadas/${id}`);

  return result.data;
};

// Pestaña A AUTORIZAR
export const postPendingAuthorization = async (body) => {
  const result = await api.post('/v2/SolicitudesServicio/pendienteDeAutorizar', body);

  return result.data;
};

export const postPendingAuthorizationCalendar = async (id, body) => {
  const result = await apiCertificationsMaster.get(
    `/v1/SolicitudServicio/${id}/Costos/Calendario?nroContrato=${body.numeroContrato}`
  );

  return result.data;
};

// Descarga excel reporte de proveedor
export const postReportExcel = async (body) => {
  const result = await api.post(`/v1/Reportes/Solicitudes/Excel`, body);

  downloadBase64(result.data, 'Reporte', 'xlsx');
};

// Opciones de estado de parte para filtro VE:
export const workPartStatusOptionsForInspector = async () => {
  const result = await api.get(`/v1/PartesTrabajo/gruposEstados`);

  return result.data;
};

// Opciones de estado de parte para filtro VS:
export const workPartStatusOptionsForAproover = async () => {
  const result = await api.get(`/v1/PartesTrabajo/estados`);

  return result.data;
};

export const getDetailUbicationWithoutEvent = async ({ requestId }) => {
  const result = await api.get(`/v1/SolicitudesServicio/${requestId}/ubicacionSinEvento`);

  return result.data;
};

export const editEventForServiceRequest = async ({ requestId, body }) => {
  const result = await api.put(`/v1/SolicitudesServicio/${requestId}/EventosPozos`, body);

  return result.data;
};

export const getTypesOfImputationForServiceRequest = async (id, solicitudMensualizada) => {
  const result = await api.get(
    `/v1/SolicitudesServicio/${id}/tiposImputaciones?solicitudMensualizada=${solicitudMensualizada}`
  );

  return result.data;
};
// Check duplicity in requests

export const checkDuplicityService = async (body) => {
  const result = await api.post('/v1/SolicitudesServicio/duplicidad', body);

  return result.data;
};

export const getRequestsService = async (value) => {
  const result = await api.get(`/v1/SolicitudesServicio/${value}`);

  return result.data;
};

export const getPosition = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicio/${id}/posiciones`);

  return result.data;
};

export const getUbicationByUbicationType = async ({ value, typeUbication }) => {
  const result = await api.get(`/v1/SolicitudesServicio/ubicaciones/${typeUbication}/${value}`);

  return result.data;
};
export const getLines = async (id, positionId) => {
  const result = await api.get(`/v1/SolicitudesServicio/${id}/posiciones/${positionId}/lineas`);

  return result.data;
};

export const getEquipamentTower = async ({ value, typeUbication }) => {
  const result = await api.get(
    `/v1/SolicitudesServicio/ubicaciones/${typeUbication}/equiposDeTorre?nombreEquipo=${value}`
  );

  return result.data;
};

export const getFiltrosPTSDS = async (id) => {
  const result = await api.get(`/v1/SolicitudesServicio/${id}/filtros`);

  if (result.data.filtros) {
    const parsedBody = JSON.parse(result.data.filtros);

    return parsedBody;
  }

  return [];
};

export const postFiltrosPTSDS = async (id, body) => {
  const requestBody = JSON.stringify(body);
  const nestedRequestBody = JSON.stringify(requestBody);

  const result = await api.post(`/v1/SolicitudesServicio/${id}/filtros`, nestedRequestBody);

  return result.data;
};

export const getImputationObjectsSDSVE = async ({ id, dateInit, dateEnd }) => {
  const params = new URLSearchParams();

  if (dateInit) params.append('desde', dateInit);
  if (dateEnd) params.append('hasta', dateEnd);
  const result = await api.get(`v1/SolicitudesServicio/${id}/objetosImputacion?${params}`);

  return result.data;
};

export const getImputationObjectsMSDSVE = async ({ id, idLocation, dateInit, dateEnd }) => {
  const params = new URLSearchParams();

  if (dateInit) params.append('desde', dateInit);
  if (dateEnd) params.append('hasta', dateEnd);

  const result = await api.get(
    `v1/SolicitudesServicioMensualizada/${id}/ubicaciones/${idLocation}/objetosImputacion?${params}`
  );

  return result.data;
};

export const postImputationObjectsMsds = async (body, id, ubicationId) => {
  const result = await api.patch(
    `v1/SolicitudesServicioMensualizada/${id}/ubicaciones/${ubicationId}/objetosImputacion`,
    body
  );

  return result.data;
};

export const getRequestsServiceByAsocietyUser = async (value) => {
  const result = await api.get(`/v1/SolicitudesServicio/SolicitudesAprobador/${value}`);

  return result.data;
};

export const getRequestsServiceByApprover = async (value) => {
  const searchValue = String(value || '')?.trim();

  if (!value || searchValue.length < 4) {
    return [];
  }
  const params = new URLSearchParams();

  if (searchValue) {
    params.append('solicitud', searchValue);
  }

  const result = await api.get(`v2/SolicitudesServicio/aprobador/solicitudes-visibles?${params}`);

  return result.data;
};

export const getRequestServices = async (requestServiceValue) => {
  const result = await api.get(`/v1/Certificacion/solicitudes/${requestServiceValue}`);

  return result.data;
};

export const getProvidersForAprooverV1 = async (body) => {
  const result = await api.post('/v1/SolicitudesServicio/aprobador/proveedores', body);

  return result.data;
};

export const getAprooverContractsV1 = async (body) => {
  const result = await api.post('/v1/SolicitudesServicio/aprobador/contratos', body);

  return result.data;
};
